import * as domainConstants from "../../constants/DomainConstants";
import { uploadOneInfrastructuurFile, deleteOneInfrastrucuurFile } from "../common/DownloadUploadFilesHelper";

import mergeDeep from "../../util/mergeDeep.js";
import showToastr, { showToastrError, showToastrInfo, showToastrSuccess } from "../../util/toastr.js";
import redirector from "../../util/redirector";
import GenerateGuid from "../../util/guid";
import { orderByPropertyName } from "../../util/orderBy";
import { getStore } from "../../store/configureStore";

export default class BovenLokaliteitPerInfrastructuurPageHelper {
	constructor(context, redirector) {
		this.dispatch = getStore().dispatch;
		this.context = context;
		this.redirector = redirector;
	}

	receiveProps(nextProps) {
		const infrastructuurId = this.context.props.params.infrastructuurId;
		const dossierId = this.context.props.params.dossierId;

		if (!this.context.state.isLoading) {
			if (infrastructuurId != nextProps.infrastructuurId || !this.context.props.isLoaded) {
				this.context.setState({ isLoading: true });
				this.context.props.loadLayout("", "", dossierId, false, null, nextProps.infrastructuurId, true);
				this.context.props.loadBovenLokaliteitPerInfrastructuur(nextProps.infrastructuurId).then(result => { this.context.setState({ hasUnsavedChanges: false, isLoading: false }); });

				if (dossierId) {
					this.context.props.getContent(dossierId, domainConstants.DocumentTab.BovenLokaliteit, nextProps.infrastructuurId)
						.then(result => {
							if (result.success) {
								this.context.setState(
									{
										documenten: result.data
									});
							} else {
								showToastrError("Laden van het dossier is mislukt");
								throw new Error("getContent load failed"); //Stops promise
							}
						});
				}
			}
			else {
				if (!this.context.state.addBovenlokaliteitPerInfraModalIsOpen && this.context.props.bovenLokaliteitPerInfrastructuur !== nextProps.bovenLokaliteitPerInfrastructuur) {// || nextProps.bovenLokaliteitPerInfrastructuurSaved) {
					const bovenLokaliteitPerInfrastructuur = this.context.props.bovenLokaliteitPerInfrastructuur;

					if (dossierId) {
						this.context.props.getContent(dossierId, domainConstants.DocumentTab.BovenLokaliteit, nextProps.infrastructuurId)
							.then(result => {
								if (result.success) {
									this.context.setState(
										{
											documenten: result.data
										});
								} else {
									showToastrError("Laden van het dossier is mislukt");
									throw new Error("getContent load failed"); //Stops promise
								}
							});
					}

					this.context.setState({ hasUnsavedChanges: !this.context.props.bovenLokaliteitPerInfrastructuurSaved, fileSessionStarted: this.context.props.fileSessionStarted, documenten: this.context.props.documenten, bovenLokaliteitPerInfrastructuur: mergeDeep({}, bovenLokaliteitPerInfrastructuur), mapKey: GenerateGuid(), center: { lat: parseFloat(bovenLokaliteitPerInfrastructuur.breedtegraad), lng: parseFloat(bovenLokaliteitPerInfrastructuur.lengtegraad) } });
				}
				else {
					if (!this.context.state.bovenLokaliteitPerInfrastructuur) {
						const bovenLokaliteitPerInfrastructuur = this.context.props.bovenLokaliteitPerInfrastructuur;
						if (bovenLokaliteitPerInfrastructuur.infrastructuurId != nextProps.infrastructuurId) {
							this.context.setState({ isLoading: true });
							this.context.props.loadBovenLokaliteitPerInfrastructuur(nextProps.infrastructuurId).then(result => { this.context.setState({ hasUnsavedChanges: false, isLoading: false }); });
						}

						this.context.setState({ hasUnsavedChanges: !this.context.props.bovenLokaliteitPerInfrastructuurSaved, fileSessionStarted: this.context.props.fileSessionStarted, documenten: this.context.props.documenten, bovenLokaliteitPerInfrastructuur: mergeDeep({}, bovenLokaliteitPerInfrastructuur), mapKey: GenerateGuid(), center: { lat: parseFloat(bovenLokaliteitPerInfrastructuur.breedtegraad), lng: parseFloat(bovenLokaliteitPerInfrastructuur.lengtegraad) } });
					}
				}
			}
		}

		if (this.context.props.bovenLokaliteitPerInfrastructuur !== nextProps.bovenLokaliteitPerInfrastructuur) {
			if (nextProps.bovenLokaliteitPerInfrastructuur.tabTitel) {
				this.context.props.loadLayout(nextProps.bovenLokaliteitPerInfrastructuur.naam, nextProps.bovenLokaliteitPerInfrastructuur.tabTitel, nextProps.dossierId, nextProps.bovenLokaliteitPerInfrastructuur.typeDossier, nextProps.infrastructuurId, (nextProps.bovenLokaliteitPerInfrastructuur.redenVanStatus != "121450000" && nextProps.bovenLokaliteitPerInfrastructuur.redenVanStatus !== 121450000));
			}
			if (this.context.state.currentSportinfrastructurenInDeBuurtIndex) {
				this.context.setState({
					bovenLokaliteitPerInfrastructuur: mergeDeep({}, nextProps.bovenLokaliteitPerInfrastructuur),
					currentSportinfrastructuurInDeBuurt: mergeDeep({}, nextProps.bovenLokaliteitPerInfrastructuur.sportinfrastructurenInDeBuurt[this.context.state.currentSportinfrastructurenInDeBuurtIndex]),
					titleSet: nextProps.bovenLokaliteitPerInfrastructuur.tabTitel,
					mapKey: GenerateGuid()
				});
			} else {
				this.context.setState({
					bovenLokaliteitPerInfrastructuur: mergeDeep({}, nextProps.bovenLokaliteitPerInfrastructuur),
					titleSet: nextProps.bovenLokaliteitPerInfrastructuur.tabTitel,
					mapKey: GenerateGuid()
				});
			}
			this.context.setState({
				newCoordinates: Object.assign({}, { lat: nextProps.bovenLokaliteitPerInfrastructuur.breedtegraad, lng: nextProps.bovenLokaliteitPerInfrastructuur.lengtegraad }),
				center: Object.assign({}, { lat: parseFloat(nextProps.bovenLokaliteitPerInfrastructuur.breedtegraad), lng: parseFloat(nextProps.bovenLokaliteitPerInfrastructuur.lengtegraad) }),
				mapKey: GenerateGuid()
			});
		}
	}

	init() {
		const dossierId = this.context.props.dossierId;

		if (this.context.props.bovenLokaliteitPerInfrastructuur) {
			this.context.props.loadLayout(this.context.props.bovenLokaliteitPerInfrastructuur.naam, this.context.props.bovenLokaliteitPerInfrastructuur.tabTitel, dossierId, this.context.props.bovenLokaliteitPerInfrastructuur.typeDossier, this.context.props.infrastructuurId, (this.context.props.bovenLokaliteitPerInfrastructuur.redenVanStatus != "121450000" && this.context.props.bovenLokaliteitPerInfrastructuur.redenVanStatus !== 121450000));
		}
		else {
			this.context.props.loadLayout("", "", dossierId, null, this.context.props.infrastructuurId, true);
		}

		this.context.props.getSjablonen(domainConstants.DocumentTab.BovenLokaliteit)
			.then(result => {
				if (result.success) {
					this.context.setState(
						{
							sjablonen: result.data
						});
				} else {
					showToastrError("Laden van de sjablonen is mislukt");
					throw new Error("getSjablonen load failed"); //Stops promise
				}
			});

		this.context.props.loadInfrastructurenByDossierId(dossierId);
	}

	saveBovenLokaliteitPerInfrastructuur(toSaveBovenLokaliteitPerInfrastructuur, documenten) {
		this.context.props.saveBovenLokaliteitPerInfrastructuur(toSaveBovenLokaliteitPerInfrastructuur, documenten)
			.then((notification) => {
				let isSaved = showToastr(notification);

				const errors = this.context.props.errors ? (this.context.props.errors.sportinfrastructurenInDeBuurt ? this.context.props.errors.sportinfrastructurenInDeBuurt[this.context.state.currentSportinfrastructurenInDeBuurtIndex] : null) : null;

				if ((isSaved && notification === domainConstants.SUCCESS) || !errors || errors.tienMinutenWandelen) {
					this.context.setState({ hasUnsavedChanges: false, currentSportinfrastructuurInDeBuurt: null, currentSportinfrastructurenInDeBuurtIndex: null });
				} else {
					this.context.setState({ hasUnsavedChanges: false });
				}
			});
	}

	handleFileRequest(component, actionParam, fileProcess) {
		if (!this.context.state.fileSessionStarted) {
			this.context.props.startFileSession(this.context.props.dossierId, domainConstants.DocumentTab.BovenLokaliteit, this.context.props.infrastructuurId)
				.then(result => {
					if (!result.success) {
						showToastrError("Verwerken van bestand is mislukt");
						throw new Error("File process failed"); //Stops promise
					} else {
						this.context.setState({ fileSessionStarted: true });
					}
				}).then(() => fileProcess(component, actionParam));
		}
		else
			fileProcess(component, actionParam);
	}

	handleOnDropFiles(component, files) {
		this.handleFileRequest(component, files, () => { files.forEach(file => uploadOneInfrastructuurFile(this.context, this.context.props.uploadDocument, this.context.props.dossierId, this.context.props.infrastructuurId, domainConstants.DocumentTab.BovenLokaliteit, component, file)); });
	}

	handleOnDeleteFile(component, fileName) {
		this.handleFileRequest(component, fileName, () => { deleteOneInfrastrucuurFile(this.context, this.context.props.deleteDocument, this.context.props.dossierId, this.context.props.infrastructuurId, domainConstants.DocumentTab.BovenLokaliteit, component, fileName); });
	}

	handleOnChange(event, i) {

		const field = event.target.name;
		const value = event.target.value;

		if (field.indexOf("aantalBedden") !== -1 &&
			(value && (value.toString().indexOf('.') !== -1
				|| value.toString().indexOf(',') !== -1
				|| value % 1 != 0)))
			return;

		if ((field.indexOf("oppervlakte") !== -1
			|| field.indexOf("hoogte") !== -1
			|| field.indexOf("volume") !== -1
			|| field.indexOf("aantalBedden") !== -1)
			&& value < 0)
			return;

		const bovenLokaliteit = this.context.state.bovenLokaliteitPerInfrastructuur;
		if (i != null) {
			const replacedField = field.replace("" + i, "");
			const sportInfraStructuurToUpdate = bovenLokaliteit.sportinfrastructurenInDeBuurt[i];
			sportInfraStructuurToUpdate[replacedField] = value;
			const sportInfraStructuurToUpdateOpDeKaart = bovenLokaliteit.sportinfrastructurenOpKaart.find(x => x.id === sportInfraStructuurToUpdate.id);

			if (sportInfraStructuurToUpdateOpDeKaart)
				sportInfraStructuurToUpdateOpDeKaart[replacedField] = value;
		} else {
			bovenLokaliteit[field] = value;
		}

		return this.context.setState(
			{
				bovenLokaliteitPerInfrastructuur: bovenLokaliteit,
				hasUnsavedChanges: true
			});
	}

	handleOnSave(event) {
		event.preventDefault();

		//Add to list
		if (this.context.state.currentSportinfrastructurenInDeBuurtIndex != null) {
			const bovenLokaliteit = this.context.state.bovenLokaliteitPerInfrastructuur;
			bovenLokaliteit.sportinfrastructurenInDeBuurt[this.context.state.currentSportinfrastructurenInDeBuurtIndex] = this.context.state.currentSportinfrastructuurInDeBuurt;
		}

		if (this.context.state.fileSessionStarted) {
			showToastrInfo("Verwerken van bestanden. Even geduld");

			this.context.props.endFileSession(this.context.props.dossierId, domainConstants.DocumentTab.BovenLokaliteit, this.context.props.infrastructuurId)
				.then(result => {
					if (!result.success) {
						showToastrError(domainConstants.HAS_FILE_EXCEPTION);
						throw new Error("File process failed"); //Stops promise
					} else {
						this.context.setState({ fileSessionStarted: false });
						showToastrSuccess("Verwerken van bestanden gelukt");
					}
				});
		}

		this.saveBovenLokaliteitPerInfrastructuur(this.context.state.bovenLokaliteitPerInfrastructuur, this.context.state.documenten);
	}

	handleOnRemoveSportInfrastructuur(event, i, infraBinnen600m) {
		this.context.setState({ removeModalIsOpen: true, removeInfraIndex: i, infraBinnen600m });
	}

	handleOnGoToRemoveSportInfrastructuur() {
		const iVoorInDeBuurt = this.context.state.removeInfraIndex;
		const bovenLokaliteit = this.context.state.bovenLokaliteitPerInfrastructuur;
		const infraBinnen600m = this.context.state.infraBinnen600m;
		const sportinfrastructurenInDeBuurt = infraBinnen600m.toString() === "true" ? orderByPropertyName(bovenLokaliteit.sportinfrastructurenInDeBuurt.filter(i => i.behoortTotMijnProject === false && i.tienMinutenWandelen), "naam") : orderByPropertyName(bovenLokaliteit.sportinfrastructurenInDeBuurt.filter(i => i.behoortTotMijnProject === false && i.tienMinutenWandelen === false), "naam");
		const sportInfraId = sportinfrastructurenInDeBuurt[iVoorInDeBuurt].id;
		const iVoorKaart = bovenLokaliteit.sportinfrastructurenOpKaart.indexOf(bovenLokaliteit.sportinfrastructurenOpKaart.find(x => x.id === sportInfraId));
		const infraindex = bovenLokaliteit.sportinfrastructurenInDeBuurt.indexOf(bovenLokaliteit.sportinfrastructurenInDeBuurt.find(x => x.id === sportInfraId));

		bovenLokaliteit.sportinfrastructurenInDeBuurt.splice(infraindex, 1);
		bovenLokaliteit.sportinfrastructurenOpKaart.splice(iVoorKaart, 1);

		return this.context.setState({
			removeModalIsOpen: false,
			removeInfraIndex: null,
			bovenLokaliteitPerInfrastructuur: bovenLokaliteit,
			hasUnsavedChanges: true
		});
	}

	handleOnCancelRemoveSportInfrastructuur() {
		this.context.setState({ removeModalIsOpen: false, removeInfraIndex: null });
	}

	handleOnEdit(event, i) {
		let hasUnsavedChangesTemp = !this.context.state.hasUnsavedChanges;

		this.context.setState({
			hasUnsavedChanges: false,
			shouldKeepProject: true
		}, () => {
			this.context.props.bovenLokaliteitPerInfrastructuurLoaded(this.context.state.bovenLokaliteitPerInfrastructuur, this.context.state.documenten, null, false, this.context.state.fileSessionStarted, hasUnsavedChangesTemp);
			redirector.goTo(`bovenlokaliteit/${this.context.props.bovenLokaliteitPerInfrastructuur.dossierId}/edit/infraInDeBuurt/${this.context.props.infrastructuurId}/${i}`);
		});
	}

	handleOnAddBovenlokaliteitPerInfraModalIsOpen() {
		return this.context.setState({
			addBovenlokaliteitPerInfraModalIsOpen: true,
			shouldKeepProject: true
		});
	}

	handleOnGoToAddBovenlokaliteitPerInfra() {
		this.context.props.bovenLokaliteitPerInfrastructuurLoaded(this.context.state.bovenLokaliteitPerInfrastructuur, this.context.state.documenten, null, false, this.context.state.fileSessionStarted, !this.context.state.hasUnsavedChanges);

		this.context.setState({
			hasUnsavedChanges: false,
			shouldKeepProject: true
		}, () => {
			redirector.goTo(`bovenlokaliteit/${this.context.props.bovenLokaliteitPerInfrastructuur.dossierId}/add/infraInDeBuurt/${this.context.props.infrastructuurId}`);
		});
	}

	handleOnCancelAddBovenlokaliteitPerInfraModalIsOpen() {
		return this.context.setState({
			addBovenlokaliteitPerInfraModalIsOpen: false
		});
	}
}